/**
 * region for libraries*/
import React, { Component } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import { AppBar, Drawer } from "@material-ui/core";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

/**
 * region for styles*/
import { layoutBrokenUrlsStyle } from "./style/layoutBrokenUrlsStyle";

/**
 * region for containers*/
import HeaderBrokenUrls from "../../../containers/brokenurls/HeaderBrokenUrls";

import ReportBrokenUrls from "../../../containers/brokenurls/ReportBrokenUrls";

/**
 * region for hepers*/

/**
 * region for constans*/

class LayoutBrokenUrls extends Component {
  state = {
    showMenu: false, //permanet disabled
  };

  

  render() {
    const { classes } = this.props;
    const { showMenu } = this.state;
    return (
      <Router>
        <div className={classes.root}>
          <AppBar className={clsx(classes.appBar)} position="absolute" color="inherit" elevation={0}>
            <HeaderBrokenUrls />
          </AppBar>
          {showMenu && <Drawer classes={{ paper: clsx(classes.drawerPaper) }} open={true} variant="permanent"></Drawer>}
          <div className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Switch>
              <Route exact path="/LayoutBrokenUrls">
                <ReportBrokenUrls />
              </Route>
            </Switch>
          </div>
        </div>
      </Router>
    );
  }
}
LayoutBrokenUrls.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(layoutBrokenUrlsStyle)(LayoutBrokenUrls);
